import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import type {GlowType} from '@PosterWhiteboard/poster/poster-backend.types';

interface BaseGlowColorOptionProps {
  glowType: GlowType;
  glowColor: RGBA;
  onClickColorFill(): void;
  className?: string;
}

export function BaseGlowColorOption({className = '', ...props}: BaseGlowColorOptionProps): ReactElement<any> {
  const getColorFillData = (): ColorFillStorage[] => {
    return [
      {
        id: 'item-glow-color-fill',
        color: getColorObjectArrayFromFillColor([props.glowColor]),
      },
    ];
  };

  return (
    <ContextualMenuColorFillOption
      className={className}
      id="glow-color-fill-option"
      label={window.i18next.t('pmwjs_color')}
      data={getColorFillData()}
      onClick={(): void => {
        props.onClickColorFill();
      }}
    />
  );
}
